import React, {createContext, useContext} from 'react'

interface UIContextProps {
    isUserOnDiscord: boolean
    /**
     * @deprecated Temporary fix for mobile layout whilst design is reconciled, avoid use of
     */
    isUserOnMobile: boolean
    isUserOnMobileWebBrowser: boolean
    isUserOnTablet: boolean
}

const UIContext = createContext<UIContextProps | undefined>(undefined)

export const useUIContext = () => {
    const context = useContext(UIContext)
    if(!context) throw new Error('UIContext not found')
    return context
}

interface UIContextProviderProps {
    isUserOnDiscord: boolean
    isUserOnMobile: boolean
    isUserOnMobileWebBrowser: boolean
    isUserOnTablet: boolean
    children: React.ReactNode
}

export const UIContextProvider = ({
    isUserOnDiscord,
    isUserOnMobile,
    isUserOnMobileWebBrowser,
    isUserOnTablet,
    children,
}: UIContextProviderProps) => <UIContext.Provider value={{
    isUserOnDiscord: isUserOnDiscord,
    isUserOnMobile: isUserOnMobile,
    isUserOnMobileWebBrowser: isUserOnMobileWebBrowser,
    isUserOnTablet: isUserOnTablet,
}}>
    {children}
</UIContext.Provider>
